module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-backoffice-create-note"
  }, [_c('modal-reveal', {
    ref: "modalAddNote",
    attrs: {
      "sizing": "tiny"
    }
  }, [_c('div', {
    staticClass: "text-right",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-2x"
  })]), _c('NoteForm', {
    on: {
      "completed": _vm.createNote
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a89f7d7c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/CreateNoteModal.vue
// module id = 2638
// module chunks = 1